export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Bons Relacionamentos",
  headline: "Criando conexões",
  description:
    "Uma boa comunicação evita erros e mal entendidos, o que ajuda a manter o fluxo do trabalho. Lembrando que se comunicar não envolve somente saber como e quando se expressar, mas também saber ouvir. Uma boa comunicação facilita a criação e manutenção de bons relacionamentos.",
  imgStart: false,
  img: "/images/svg-1.svg",
  alt: "imagem",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Além do veículo",
  headline: "Clareza",
  description:
    "Não é só o veículo que usamos para nos comunicar que conta, mas também a forma, o conteúdo e a linguagem que utilizamos para isso.",
  imgStart: true,
  img: "/images/svg-2.svg",
  alt: "lorem",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjThree = {
  id: "signup",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Valor",
  headline: "O poder da comunicação",
  description:
    "As pessoas que se utilizam da comunicação assertiva são capazes de mostrar o seu ponto de vista respeitando a opinião do outros. Conseguem diferenciar situações favoráveis das desfavoráveis e recusar-se a fazer algo que não estão de acordo.",
  imgStart: false,
  img: "/images/svg-3.svg",
  alt: "lorem",
  dark: false,
  primary: false,
  darkText: true,
};